import styled from 'styled-components'


export const TableStickyStyles = styled.div` 
  pointer-events: ${(p) => {
    return p.isLoading ? 'none' : ''
  }};

  .table {
    border: 1px solid #ddd;
    border-radius: 4px;

    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }               
    }
    
    .th {
      background-color: rgb(244,244,244);
      border-color: #FFFFFF;
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      color: rgba(32, 32, 32, 0.5);
      border-right: 1px solid #ddd;
    }
    
    .td {
      font-size: 14px;
      line-height: 16px;
      font-weight: 400;
      color: rgba(32, 32, 32);
      background-color: #FFFFFF;

    }

    .th,
    .td {
      text-align: center;
      padding: 16px 24px;  
      height: 48px;      
      display: flex !important;
      align-items: center;
      justify-content: flex-start;
      white-space: nowrap;
      border-bottom: 1px solid #ddd;         
      overflow: hidden;
      
      :first-child {
        padding: 16px;
        
      }

      :last-child {
        padding: 16px;
        border-right: 0;
        justify-content: flex-end;
      }

      .resizer {
        display: inline-block;
        width: 5px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;

        &.isResizing {
          background: red;
        }
      }
    }

    &.sticky {
      overflow: scroll;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }

      .header {
        top: 0;
        background: rgba(32, 32, 32, 0.5);
        box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
      }

      .footer {
        bottom: 0;
        box-shadow: 0 -3px 3px #ccc;
      }

      .body {
        position: relative;
        z-index: 0;
      }

      [data-sticky-td] {
        position: sticky;
      }

      [data-sticky-last-left-td] {
        box-shadow: 2px 0 3px #ccc;
      }

      [data-sticky-first-right-td] {
        box-shadow: -2px 0 3px rgba(32, 32, 32, 0.05);
      }
    }
  }
`

export const TableStickyNoResultsWrapper = styled.div`
  text-align: center;
  margin-top: 120px;
  font-size: 18px;
  line-height: 32px;
  color: rgba(32, 32, 32, 0.5);
`
